var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"htmlBoxQRCode"}},[_c('templatePrintSerialNumber',{key:_vm.componentPrint,attrs:{"title":_vm.title,"note":_vm.note,"hotline":_vm.hotline,"listData":_vm.lstProducts}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }